import React from 'react';

import TableElement from '@/elements/Table';
import styled from '@/styles';

const Wrapper = styled('div', {
  variants: {
    spacing: {
      false: {
        overflowX: 'auto',
      },
    },
  },
});

type TableProps = {
  spacing?: boolean;
  children?: React.ReactNode;
};

const Table: React.FC<TableProps> = ({ children, spacing }) => {
  return (
    <Wrapper spacing={spacing}>
      <TableElement spacing={spacing}>{children}</TableElement>
    </Wrapper>
  );
};

export default Table;
